// extracted by mini-css-extract-plugin
module.exports = {"visibleMobile":"VenueAdditionalDetails--visibleMobile","hiddenMobile":"VenueAdditionalDetails--hiddenMobile"};